import styled from "styled-components";
import { colorPrimary, colorSecondary, colorWhite, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledFooter = styled.footer.attrs({
  className: "footer-section",
})`
  background-color: ${colorSecondary};
  display: flex;
  justify-content: center;
  padding: 32px 15px;

  .footer {
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: ${BreakPoints.md}) {
      width: ${ContentWidths.md};
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
    }

    &__top {
      display: flex;
      flex-direction: column;

      @media (min-width: ${BreakPoints.md}) {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    &__info {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (min-width: ${BreakPoints.md}) {
        width: 210px;
        align-items: flex-start;
      }

      & > img {
        max-height: 32px;
        margin-bottom: 16px;
      }
    }

    &__description {
      color: ${colorWhite};
      font-family: Rubik;
      font-size: 0.75rem;
      text-align: center;
      font-weight: 400;
      letter-spacing: 0.025em;
      margin: 0 0 32px; 0;

      @media (min-width: ${BreakPoints.md}) {
        text-align: left;
      }
    }

    &__links {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 32px;

      @media (min-width: ${BreakPoints.md}) {
        max-width: 180px;
        padding: 0 15px;
        align-items: flex-start;
      }
    }

    &__link-category {
      font-family: Pitch Sans Bold;
      font-size: 0.8125rem;
      font-weight: bold;
      text-transform: uppercase;
      color: ${hex2rgba(colorWhite, 0.5)};
      letter-spacing: 0.2em;
      margin: 0 0 8px 0;
    }

    &__link-list {
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (min-width: ${BreakPoints.md}) {
        align-items: flex-start;
      }
    }

    &__link {
      list-style-type: none;
      margin: 0;
      padding: 8px 0;
      color: ${colorPrimary};
      font-family: Pitch Sans Medium;
      font-size: 0.875rem;
      letter-spacing: 0.025em;
      line-height: 1;

      & > a {
        color: inherit;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    &__socials {
      display: flex;
      justify-content: center;
      margin-bottom: 32px;

      @media (min-width: ${BreakPoints.md}) {
        flex-direction: column;
        justify-content: flex-start;
      }

      @media (min-width: ${BreakPoints.lg}) {
        flex-direction: row;
        justify-content: center;
        margin: 0;
      }
    }

    &__social-icon {
      background-color: ${hex2rgba(colorWhite, 0.05)};
      border-radius: 100%;
      margin: 0 8px;

      @media (min-width: ${BreakPoints.md}) {
        margin: 8px 0;
      }

      @media (min-width: ${BreakPoints.lg}) {
        margin: 0 8px;
        height: 32px;
      }

      &:hover {
        box-shadow: 0 0 0 2px ${colorPrimary};
      }
    }

    &__bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: Rubik;
      font-size: 0.75rem;
      font-weight: 300;
      letter-spacing: 0.025em;
    }

    &__copyright {
      color: ${hex2rgba(colorWhite, 0.5)};
      margin: 0;
    }

    &__policies {
      margin: 0;
      padding: 0;
      display: flex;
    }
    
    &__policy {
      list-style-type: none;
      margin: 0;
      padding: 0 4px;
      border-left: 1px solid ${hex2rgba(colorWhite, 0.5)};
      color: ${colorPrimary};
      opacity: 0.5;

      &:first-child {
        border: none;
      }

      & > a {
        color: inherit;
        text-decoration: none;
      }
    }

`;
